<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Border Lord</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="adCardPage" id="adc"><a id="page05"><h2 class="adCardHead"><span class="bold"><span><em class="italic"><span>Available from Harlequin</span></em></span></span><sup>®</sup><span class="bold"><span><em class="italic"><span>Historical and<br/>
SOPHIA JAMES</span></em></span></span></h2><p class="adCardText"><span><em class="italic"><span>Fallen Angel</span></em> #171</span></p><p class="adCardText"><span><em class="italic"><span>Ashblane’s Lady</span></em> #838</span></p><p class="adCardText"><span><em class="italic"><span>Masquerading Mistress</span></em> #875</span></p><p class="adCardText"><span><em class="italic"><span>High Seas to High Society</span></em> #888</span></p><p class="adCardText"><span><em class="italic"><span>The Border Lord</span></em> #946</span></p></a></div>
<a id="page05">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// borderlordthe_adc.vue?949302d8